function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState, useEffect } from "react";
import { Form, Input, Button, Alert, Select, Modal } from "antd";
import Common from "../includes/Common";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var TextArea = Input.TextArea;
var AddExpenseCategory = function AddExpenseCategory(_ref) {
  var handler = _ref.handler;
  var _Modal$useModal = Modal.useModal(),
    _Modal$useModal2 = _slicedToArray(_Modal$useModal, 2),
    confirm = _Modal$useModal2[0].confirm,
    contextHolder = _Modal$useModal2[1];
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isFormLoading = _useState2[0],
    setIsFormLoading = _useState2[1];
  var _useState3 = useState(''),
    _useState4 = _slicedToArray(_useState3, 2),
    formError = _useState4[0],
    setFormError = _useState4[1];
  var _useState5 = useState(''),
    _useState6 = _slicedToArray(_useState5, 2),
    formSuccess = _useState6[0],
    setFormSuccess = _useState6[1];
  var _Form$useForm = Form.useForm(),
    _Form$useForm2 = _slicedToArray(_Form$useForm, 1),
    form = _Form$useForm2[0];
  var onFinish = function onFinish(values) {
    confirm({
      title: /*#__PURE__*/_jsx("b", {
        children: "Confirmez - vous ?"
      }),
      content: /*#__PURE__*/_jsxs("p", {
        children: ["L'ajout de la cat\xE9gorie - ", values.label, " ?"]
      }),
      onOk: function onOk() {
        exec(values);
      }
    });
  };
  var exec = function exec(values) {
    setIsFormLoading(true);
    setFormError('');
    setFormSuccess('');
    var formData = new FormData();
    formData.append('label', values.label);
    formData.append('user_id', Common.currentUser.id);
    axios.post(Common.baseApiUrl + 'addexpensecategory', formData).then(function (response) {
      if (response.data.status == 200) {
        handler();
      } else {
        setFormError(response.data.message);
      }
    })["catch"](function (error) {
      setFormError('Une erreur est survenue');
    })["finally"](function () {
      setIsFormLoading(false);
    });
  };
  useEffect(function () {
    form.setFieldsValue({
      description: ''
    });
  }, []);
  return /*#__PURE__*/_jsx("div", {
    style: {
      padding: "24px",
      background: "#FFFFFF",
      borderRadius: "8px"
    },
    children: /*#__PURE__*/_jsxs(Form, {
      form: form,
      size: "large",
      layout: "vertical",
      onFinish: onFinish,
      children: [/*#__PURE__*/_jsx(Alert, {
        type: "info",
        message: /*#__PURE__*/_jsx("b", {
          children: "Ajouter une cat\xE9gorie"
        }),
        description: "Les d\xE9penses internes sont class\xE9es par cat\xE9gorie pour vous permettre d'identifier les goulots d'\xE9tranglement",
        showIcon: true
      }), /*#__PURE__*/_jsx("br", {}), formError.length > 0 && /*#__PURE__*/_jsx(Form.Item, {
        children: /*#__PURE__*/_jsx(Alert, {
          type: "error",
          message: formError,
          showIcon: true
        })
      }), formSuccess.length > 0 && /*#__PURE__*/_jsx(Form.Item, {
        children: /*#__PURE__*/_jsx(Alert, {
          type: "success",
          message: formSuccess,
          showIcon: true
        })
      }), /*#__PURE__*/_jsx(Form.Item, {
        name: "label",
        label: "D\xE9signation",
        rules: [{
          required: true,
          message: 'Ce champs est obligatoire'
        }],
        children: /*#__PURE__*/_jsx(Input, {})
      }), contextHolder, /*#__PURE__*/_jsx(Form.Item, {
        children: /*#__PURE__*/_jsx(Button, {
          loading: isFormLoading,
          htmlType: "submit",
          type: "primary",
          children: /*#__PURE__*/_jsx("b", {
            children: "Ajouter"
          })
        })
      })]
    })
  });
};
export default AddExpenseCategory;